import { HTMLAttributes } from 'react';

export interface Props extends HTMLAttributes<HTMLDivElement> {
    currentCount?: string;
    totalCount?: string;
    required?: boolean;
    label: string;
}

export const Label = ({ currentCount, totalCount, required, children, label, ...rest }: Props) => {
    return (
        <div className='text-semantic-fg-base flex w-full flex-col gap-1' {...rest}>
            <div className='flex flex-row justify-between'>
                <span className='text-sm font-bold'>
                    {label} <span className='font-normal italic'>{required && '(required)'}</span>
                </span>

                {totalCount && (
                    <span className='text-sm font-bold'>
                        {currentCount}/{totalCount}
                    </span>
                )}
            </div>

            {children}
        </div>
    );
};
